import styled from 'styled-components';
import { media } from 'legacyComponents/styled/styleUtils';

import { Avatar } from 'apps/components/shared';

export const AuthorSection = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 92vw;
  max-width: 700px;
  margin: 0 auto 40px auto;
  padding: 20px 0;

  ${media.xs`
     margin: 0 auto 60px auto;
  `};
`;

export const AuthorAvatar = styled(Avatar)`
  width: 60px;
  height: 60px;
  ${media.s`
    width: 50px;
    height: 50px;
  `};
`;

export const FullName = styled.h3`
  &:hover {
    color: ${props => props.theme.color.primary};
    text-decoration: underline;
  }
  ${media.s`
    font-size: 0.95em;
    left: 65px;
  `};
`;

export const Bio = styled.p`
  margin: ${props => props.theme.spacing.small} 0;
  line-height: 1.4;
  ${media.s`
    width: 455px;
    font-size: 0.9em;
  `};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: ${props => props.theme.spacing.default};
`;
